import React, {useContext, useEffect, useState} from 'react'
import {dataContext,loaddat,localestr} from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';
import Panel from '../cmp/Panel'
import md5 from '../md5'
import {MenuData} from '../menudata'
import Menu from '../cmp/menu.js';
import EditImg from '../cmp/EditImg.js';


function CatUsersEdit({data,actions}){
    let wndData = "";
    if (data) wndData = data.wndData;
    else wndData = actions.getWndData();
    const setWndData = actions.setWndData;
    const tabClose = actions.tabClose;

    const context = useContext(dataContext);
    const saveData = context.saveData;
    const msg = context.msg;
    const inputLongText = context.inputText;
    const sysConst = context.data['sysConst'];

    const [URtemplates, setURTemplates] = useState([]);

    const setValue = (name, data) => {
        let newData = { ...wndData }
        if (data === '') newData[name] = null
        else newData[name] = data
        console.log(name, data)
        if (name === 'push_delete') newData.push_subscr = null
        else if (name === 'terminal' && data && data.id) {
            if(data.device?.value!=='6'&&data.device?.value!=='7') {
                msg('Не правильний тип пристрою!', null, [
                { caption: 'OK', action: () => {} },
            ])
            return
            }
        }
        setWndData(newData)
        if (name === 'urGetPush' && parseInt(data))
            msg('При авторизації у Cocktail Front на пристрої\nкористувача потрібно надати відповідні дозволи!', null, [
                { caption: 'OK', action: () => {} },
            ])
    }

    const setCheck = (objName, fieldName, value, onFields = [], offFields = []) => {
        let newData = { ...wndData };
        if (!newData[objName]) newData[objName] = {};
        newData[objName][fieldName] = parseInt(value) || 0;
        if (newData[objName][fieldName]) {
            onFields.forEach((el) => (newData[objName][el] = 1));
        } else {
            offFields.forEach((el) => (newData[objName][el] = 0));
        }
        setWndData(newData);
        if (fieldName === "urGetPush" && parseInt(data))
            msg("При авторизації у Cocktail Front на пристрої\nкористувача потрібно надати відповідні дозволи!", null, [
                { caption: "OK", action: () => {} },
            ]);
    };

    const saveValue = () => {
        let errmsg = "";
        const name = (wndData.name || "").substring(0, 25);
        const pass = wndData.pass1 ? md5(wndData.pass1) : null;
        const pass2 = wndData.pass2 ? md5(wndData.pass2) : null;
        const fio = (wndData.fio || "").substring(0, 30);
        const code = wndData.code ? md5(wndData.code.replace(/\D/g, "")) : null;
        const hall = wndData.hall || null;
        const cashAcc = wndData.cashAcc || null;
        const terminal = wndData.terminal?.id ? wndData.terminal : null;
        const ava_img = wndData.ava_img || null;
        const urAdmin = !wndData.urAdmin || wndData.urAdmin === "0" ? "0" : "1";

        const urGetPush=!wndData.urGetPush||wndData.urGetPush==='0'?'0':'1'

        let urFront = null;
        if (wndData["rightsFront"]) {
            urFront = {};
            for (const [key, value] of Object.entries(wndData["rightsFront"])) {
                if (parseInt(value) || 0) urFront[key] = 1;
            }
        }
        if (!parseInt(wndData.urFront) || 0) urFront = null;
        let urBack = null;
        if (wndData["rightsBack"]) {
            urBack = {};
            for (const [key, value] of Object.entries(wndData["rightsBack"])) {
                if (parseInt(value) || 0) urBack[key] = 1;
            }
        }
        if (!parseInt(wndData.urBack) || 0) urBack = null;

        let urShef = null;
        if (wndData["rightsShef"]) {
            urShef = {};
            for (const [key, value] of Object.entries(wndData["rightsShef"])) {
                if (parseInt(value) || 0) urShef[key] = 1;
            }
        }
        if (!parseInt(wndData.urShef) || 0) urShef = null;

        let urXprs = {};
        if (wndData["rightsShef"]) {
            urXprs = {};
            /*for (const [key, value] of Object.entries(wndData["rightsShef"])) {
                if (parseInt(value) || 0) urXprs[key] = 1;
            }*/
        }
        if (!parseInt(wndData.urXprs) || 0) urXprs = null;

        if (name === null || name === "") errmsg = localestr("Не заповнено ім'я");
        if (pass !== pass2) errmsg = errmsg + " " + localestr("Помилка вводу пароля");
        //if (fiscal!==null && fiscal!=='') if(fiscal.type!==2) errmsg=errmsg+' '+(localestr("Недопустимий тип ристрою"))
        //if (errmsg!=='') alert(errmsg)
        if (errmsg !== "") msg(errmsg, localestr("Помилка"), [{ caption: "OK", action: () => {} }]);
        else {
            let id = wndData.id;
            if (id === null || id === "" || id === undefined) {
                //let newData={status:'add',key:'CatUsers',data:{name,fio,code,urHall,urOrder,urDiscount,urReport,urTable,urReject,urFiscal,urClose,urAdmin,urInner_work,urDelivery,urPickup,urGetPush,pass,hall,cashAcc,urFront,urBack,urShef}}
                let newData = {
                    status: "add",
                    key: "CatUsers",
                    data: { name, fio, code, ava_img, urAdmin, pass, hall, cashAcc, urFront, urBack, urShef,urXprs,urGetPush, terminal },
                };
                saveData(newData, tabClose);
                //почекати ы закрити выкно
            } else {
                let newData = {
                    status: "mod",
                    key: "CatUsers",
                    data: { id, name, fio, ava_img, code, urAdmin, pass, hall, cashAcc, urFront, urBack, urShef,urXprs,urGetPush, terminal },
                };
                if (wndData.push_delete) newData.data.push_delete = 1;
                //console.log(newData)
                saveData(newData, tabClose);
            }
        }
    };

    const sendMsg = (t) => {
        let newData = { user: wndData.id, msg: t };
        loaddat("action=sendMsg&data=" + encodeURIComponent(JSON.stringify(newData)));
    };

    const setURTemplate = (id) => {
        if (id === 0) {
            setWndData({...wndData, template: { id: "", name: "", value: "" }});
            return;
        }
        const selected = URtemplates.find((item) => item.id === id);
        let newData = {
            urAdmin: selected.value.urAdmin, urBack: selected.value.urBack,
            urFront: selected.value.urFront, urShef: selected.value.urShef,
            urXprs: selected.value.urXprs, template: selected,
        };
        if (parseInt(selected.value.urBack)) newData = {...newData, rightsBack: selected.value.rightsBack}
        if (parseInt(selected.value.urFront)) newData = {...newData, rightsFront: selected.value.rightsFront}
        if (parseInt(selected.value.urShef)) newData = {...newData, rightsShef: selected.value.rightsShef}
        //if (parseInt(selected.value.urXprs)) newData = {...newData, rightsXprs: selected.value.rightsXprs}
        setWndData({...wndData, ...newData,});
    }

    const saveURTemplate = () => {
        inputLongText(localestr("Введіть назву шаблону"), "", (inputData) => {
            if (inputData === null) return;
            let newData = {
                name: inputData,
                type: '1',
                value: {
                    urAdmin: wndData.urAdmin,
                    urBack: wndData.urBack,
                    urFront: wndData.urFront,
                    urShef: wndData.urShef,
                    urXprs: wndData.urXprs,
                    rightsBack: parseInt(wndData.urBack) ? Object.fromEntries(Object.entries(wndData.rightsBack).filter(([_, v]) => parseInt(v) !== 0)): null,
                    rightsFront: parseInt(wndData.urFront) ? Object.fromEntries(Object.entries(wndData.rightsFront).filter(([_, v]) => parseInt(v) !== 0)) : null,
                    rightsShef: parseInt(wndData.urShef) ? Object.fromEntries(Object.entries(wndData.rightsShef).filter(([_, v]) => parseInt(v) !== 0)) : null,
                    //rightsXprs: parseInt(wndData.urXprs) ? Object.fromEntries(Object.entries(wndData.rightsXprs).filter(([_, v]) => parseInt(v) !== 0)) : null,
                },
            };
            loaddat("action=addTuning&data=" + encodeURIComponent(JSON.stringify(newData)), (d) => {
                if (d.status === "error") {
                    msg(d.msg, localestr('Помилка'), [{ caption: "OK", action: () => {} }]);
                } else {
                    msg(localestr('Успішно додано ') + d?.data?.name, localestr('Повідомлення'), [{ caption: "OK", action: () => {} }]);
                    loadURTemplates();
                }
            });
        });
    };

    const deleteURTemplate = (id, name) => {
        msg(localestr('Ви впевнені що хочете видалити ') + name + '?', localestr('Підтвердження дії'), [{
            caption: localestr('Так'),
            action: () => {
                loaddat("action=delTuning&data=" + encodeURIComponent(JSON.stringify({ id, name })), (d) => {
                    if (d.status === "error") {
                        msg(d.msg, localestr('Помилка'), [{ caption: "OK", action: () => {} }]);
                    } else {
                        msg(localestr('Успішно видалено ') + d?.data?.name, localestr('Повідомлення'), [
                            { caption: "OK", action: () => {} },
                        ]);
                        loadURTemplates();
                    }
                });
            },},
            { caption: localestr('Назад'), action: () => {},},
        ]);
    };

    const loadURTemplates = () => {
        loaddat("action=sysTuning&data=" + encodeURIComponent(JSON.stringify({ type: '1' })), (d) => {
            if (d.status === "error") {
                msg(d.msg, localestr('Помилка'), [{ caption: "OK", action: () => {} }]);
            } else {
                setURTemplates(d.data);
            } 
        });
    }

    useEffect(() => {
        loadURTemplates();
    // eslint-disable-next-line 
    }, []);

    let push_cont=null
    if(wndData.push_subscr&&parseInt(wndData.urGetPush)) push_cont=<>
    <div style={{display:'inline-block',color:'blue',fontSize:'small',fontStyle:'italic'}}>{localestr('можлива відправка спливаючих сповіщень на пристрій користувача')}</div>
    <div style={{display:'flex',alignItems:'center', margin:'0 2px'}}>
        <div style={{width:'55px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{inputLongText(localestr('Повідомлення'),localestr('Тестове повідомлення'),sendMsg)}}>{localestr('Тест')}</div>
        <div style={{width:'70px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setValue('push_delete',1)}}>{localestr('Скинути')}</div>
    </div></>

    let back_cont=MenuData.map(el=>{
        let itms=null
        const onFields=[]
        const offFields=[]
        if(el.isGroup) el.data.forEach(it=>{onFields.push(it.wndType);offFields.push(it.wndType);})
        
        if(el.isGroup) itms=<div style={{paddingLeft:'16px',display:'flex',flexDirection:'column'}}>{el.data.map(it=>{
            return <EditCtrl key={it.id} Capt={localestr(it.caption)} Value={(wndData['rightsBack']||{})[it.wndType]} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsBack',it.wndType,d,[el.wndType])}} width1='150' width2='20'/>
        })}</div>
        return <React.Fragment key={el.id}><EditCtrl Capt={localestr(el.caption)} Value={(wndData['rightsBack']||{})[el.wndType]} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsBack',el.wndType,d,onFields,offFields)}} width1='180' width2='20'/><br />{itms}</React.Fragment>
    })

    const frontVisibility = (parseInt(wndData.urFront)&&sysConst?.constPos)?1:0;
    const backVisibility = parseInt(wndData.urBack) || 0;
    const shefVisibility = (parseInt(wndData.urShef)&&sysConst?.constShef)?1:0;
    const fastVisibility = (parseInt(wndData.urFast)&&sysConst?.constFast)?1:0;

    return(
    <div style={{display:'flex',flexDirection:'column', margin:'4px 0',alignSelf:'flex-start',flexGrow:'10000'}}>
    <div style={{margin:'2px 0',display:'inherit'}}>
        <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d)=>{setValue('id',d)}} width1='20' width2='52' disabled={true}/>
        <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
        <EditCtrl Capt={localestr('Ім\'я в системі')} Value={wndData.name} typeVal={'text'} setVal={(d)=>{setValue('name',d)}} width1='100' width2='160'/>
    </div>
    <EditCtrl Capt={localestr('ПІБ для друку')} Value={wndData.fio} typeVal={'text'} setVal={(d)=>{setValue('fio',d)}} width1='120' width2='220'/>
    <EditCtrl Capt={localestr('Пароль')} Value={wndData.pass1} typeVal={'pass'} setVal={(d)=>{setValue('pass1',d)}} width1='120' width2='220'/>
    <EditCtrl Capt={localestr('Повтор пароля')} Value={wndData.pass2} typeVal={'pass'} setVal={(d)=>{setValue('pass2',d)}} width1='120' width2='220'/>
    <EditCtrl Capt={localestr('Основний зал')} Value={wndData.hall} typeVal={'catHalls'} setVal={(d)=>{setValue('hall',d)}} width1='120' width2='220'/>
    <EditCtrl Capt={localestr('Персональна каса')} Value={wndData.cashAcc} typeVal={'catCashAccs'} setVal={(d)=>{setValue('cashAcc',d)}} width1='120' width2='220'/>
    <EditCtrl Capt={localestr('Банківський термінал')} Value={wndData.terminal} typeVal={'catDevices'} setVal={(d)=>{setValue('terminal',d)}} width1='120' width2='220'/>
    <EditCtrl Capt={localestr('Картка доступу')} Value={wndData.code} typeVal={'pass'} setVal={(d)=>{setValue('code',d)}} width1='120' width2='220'/>
    <EditImg Capt={localestr('Аватарка')+' (50x50)'} Value={wndData.ava_img || null} setVal={(d) => setValue('ava_img', d)} width1='124' width2='50' height2='50' img_width={50} img_height={50}/>
        <EditCtrl Capt={localestr('сповіщення про онлайн замовлення')} Value={wndData.urGetPush} typeVal={'l_check'} setVal={(d)=>{setValue('urGetPush',d)}} width1='180' width2='0'/>
        {push_cont}
    <Panel caption={localestr('Права доступу')} width={340} height='2800px' open={wndData.p_right===undefined?false:wndData.p_right} setOpen={d=>setWndData({...wndData,p_right:d})}>
    <div style={{display:'flex',alignItems:'center',flexWrap:'wrap'}}>
        <Menu data={(URtemplates||[]).map((item)=>({name:item.name,action:()=>{setURTemplate(item.id)}}))}>
            <div style={{width:'195px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'}><div style={{height:'26px',lineHeight:'24px',display:'block'}}>{localestr('Заповнити з шаблону')}</div></div>
        </Menu>
        <div style={{width:'180px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveURTemplate()}}><div style={{height:'26px',lineHeight:'24px',display:'block'}}>{localestr('Зберегти як шаблон')}</div></div>
        <Menu data={(URtemplates||[]).map((item)=>({name:item.name,action:()=>{deleteURTemplate(item.id,item.name)}}))}>
            <div style={{width:'160px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'}><div style={{height:'26px',lineHeight:'24px',display:'block'}}>{localestr('Видалити шаблон')}</div></div>
        </Menu>
    </div>
    <div style={{display:'flex',flexDirection:'row',flexWrap:'wrap',margin:'2px 0',maxWidth:'1160px'}}>
        <EditCtrl Capt={localestr('повні права')} Value={wndData.urAdmin} typeVal={'l_check'} setVal={(d)=>{setValue('urAdmin',d)}} width1='90' width2='20'/>
        <div style={{minWidth:'12px',display:'inline-block',flexGrow:4,maxWidth:'24px'}}></div>
        {sysConst?.constPos?
        <EditCtrl Capt={'Front office'} title={localestr('Додаток для офіціанта')} Value={frontVisibility} typeVal={'l_check'} setVal={(d)=>{setValue('urFront',d)}} width1='80' width2='20'/>
        : null }
        <div style={{minWidth:'12px',display:'inline-block',flexGrow:4,maxWidth:'24px'}}></div>
        <EditCtrl Capt={'Back office'} title={localestr('Цей додаток (для управління всіми процесами)')} Value={backVisibility} typeVal={'l_check'} setVal={(d)=>{setValue('urBack',d)}} width1='80' width2='20'/>
        <div style={{minWidth:'12px',display:'inline-block',flexGrow:4,maxWidth:'24px'}}></div>
        {sysConst?.constShef?
        <EditCtrl Capt={'Shef'} title={localestr('Додаток для керівника')} Value={wndData.urShef} typeVal={'l_check'} setVal={(d)=>{setValue('urShef',d)}} width1='60' width2='20'/>
        : null }
        <div style={{minWidth:'12px',display:'inline-block',flexGrow:4,maxWidth:'24px'}}></div>
        {sysConst?.constXprs?
        <EditCtrl Capt={'Express'} title={localestr('Додаток для кур\'єра')} Value={wndData.urXprs} typeVal={'l_check'} setVal={(d)=>{setValue('urXprs',d)}} width1='80' width2='20'/>
        : null }
        {sysConst?.constFast?
        <EditCtrl Capt={'FastFood'} title={localestr('Додаток для фастфуду')} Value={wndData.urFast} typeVal={'l_check'} setVal={(d)=>{setValue('urFast',d)}} width1='80' width2='20'/>
        : null }
        <div style={{minWidth:'1px',display:'inline-block',flexGrow:1000,maxWidth:'1000px'}}></div>
    </div>
    <div style={{display:'flex',flexDirection:'row',flexWrap:'wrap',margin:'2px 0',maxWidth:'1160px'}}>
    <fieldset style={{minWidth:'200px',maxWidth:'360px',padding:'2px',flexBasis:'200px',flexGrow:'1',display:frontVisibility?'block':'none'}}><legend>Front office</legend>
        <EditCtrl Capt={localestr('робота з залами в закладі')} Value={(wndData['rightsFront']||{}).urInner_work} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urInner_work',d)}} width1='180' width2='20'/><br />
        <EditCtrl Capt={localestr('робота з попередніми замовленнями')} Value={(wndData['rightsFront']||{}).urBanquet} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urBanquet',d)}} width1='180' width2='20'/><br />
        <EditCtrl Capt={localestr('робота на доставку')} Value={(wndData['rightsFront']||{}).urDelivery} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urDelivery',d)}} width1='180' width2='20'/><br />
        <EditCtrl Capt={localestr('робота на самовивіз')} Value={(wndData['rightsFront']||{}).urPickup} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urPickup',d)}} width1='180' width2='20'/><br />
        <EditCtrl Capt={localestr('вибирати зали')} Value={(wndData['rightsFront']||{}).urHall} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urHall',d)}} width1='180' width2='20'/><br />
        <EditCtrl Capt={localestr('давати знижки')} Value={(wndData['rightsFront']||{}).urDiscount} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urDiscount',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('давати знижки сумою')} Value={(wndData['rightsFront']||{}).urDiscSum} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urDiscSum',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('формувати загальні звіти')} Value={(wndData['rightsFront']||{}).urReport} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urReport',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('вибирати чужі столи')} Value={(wndData['rightsFront']||{}).urTable} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urTable',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('робити відмову')} Value={(wndData['rightsFront']||{}).urReject} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urReject',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('Розділяти замовлення')} Value={(wndData['rightsFront']||{}).urBreack} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urBreack',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('закривати замовлення')} Value={(wndData['rightsFront']||{}).urClose} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urClose',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('відміняти закриття замовлення')} Value={(wndData['rightsFront']||{}).urUnclose} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urUnclose',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('відкривати чужі замовлення')} Value={(wndData['rightsFront']||{}).urOrder} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urOrder',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('редагувати чужі замовлення')} Value={(wndData['rightsFront']||{}).urNSedit} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urNSedit',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('закривати чужі замовлення')} Value={(wndData['rightsFront']||{}).urNSclose} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urNSclose',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('керувати фіск. апаратом')} Value={(wndData['rightsFront']||{}).urFiscal} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urFiscal',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('операції з касою')} Value={(wndData['rightsFront']||{}).urCashTransactions} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urCashTransactions',d,['urCashOpp0','urCashOpp1','urCashOpp2','urCashOpp3','urCashOpp4','urCashRep'],['urCashOpp0','urCashOpp1','urCashOpp2','urCashOpp3','urCashOpp4','urCashRep'])}} width1='180' width2='0'/>
        <div style={{paddingLeft:'16px',display:'flex',flexDirection:'column'}}>
            <EditCtrl Capt={localestr('Отримання з іншої каси')} Value={(wndData['rightsFront']||{}).urCashOpp0} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urCashOpp0',d,['urCashTransactions'])}} width1='150' width2='20'/>
            <EditCtrl Capt={localestr('Передача до іншої каси')} Value={(wndData['rightsFront']||{}).urCashOpp1} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urCashOpp1',d,['urCashTransactions'])}} width1='150' width2='20'/>
            <EditCtrl Capt={localestr('Оплата постачальнику')} Value={(wndData['rightsFront']||{}).urCashOpp2} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urCashOpp2',d,['urCashTransactions'])}} width1='150' width2='20'/>
            <EditCtrl Capt={localestr('Аванс від покупця')} Value={(wndData['rightsFront']||{}).urAdvance} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urAdvance',d,['urCashTransactions'])}} width1='150' width2='20'/>
            <EditCtrl Capt={localestr('Інші видатки')} Value={(wndData['rightsFront']||{}).urCashOpp3} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urCashOpp3',d,['urCashTransactions'])}} width1='150' width2='20'/>
            <EditCtrl Capt={localestr('Інші поступлення')} Value={(wndData['rightsFront']||{}).urCashOpp4} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urCashOpp4',d,['urCashTransactions'])}} width1='150' width2='20'/>
            <EditCtrl Capt={localestr('Звіт по касі')} Value={(wndData['rightsFront']||{}).urCashRep} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urCashRep',d,['urCashTransactions'])}} width1='150' width2='20'/>
        </div>
        <EditCtrl Capt={localestr('вимагати введення кількості гостей')} Value={(wndData['rightsFront']||{}).urGuests} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urGuests',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('вимагати введення чайових')} Value={(wndData['rightsFront']||{}).urTip} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFront','urTip',d)}} width1='180' width2='0'/><br />
    </fieldset>
    <fieldset style={{minWidth:'200px',maxWidth:'360x',padding:'2px',flexBasis:'200px',flexGrow:'1',display:backVisibility?'block':'none'}}><legend>Back office</legend>
    {back_cont}
    </fieldset>
    <fieldset style={{minWidth:'200px',maxWidth:'360px',padding:'2px',flexBasis:'200px',flexGrow:'1',display:shefVisibility?'block':'none'}}><legend>Shef</legend>
        <EditCtrl Capt={localestr('статистика продажів')} Value={(wndData['rightsShef']||{}).urSalesReport} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsShef','urSalesReport',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('Офіційні продажі')} Value={(wndData['rightsShef']||{}).urFiscalReport} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsShef','urFiscalReport',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('статистика ефективності')} Value={(wndData['rightsShef']||{}).urEfficiencyStatistics} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsShef','urEfficiencyStatistics',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('залишки коштів')} Value={(wndData['rightsShef']||{}).urCashBalances} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsShef','urCashBalances',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('борг постачальникам')} Value={(wndData['rightsShef']||{}).urSuppliersDebt} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsShef','urSuppliersDebt',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('види оплати')} Value={(wndData['rightsShef']||{}).urPaymentTypes} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsShef','urPaymentTypes',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('пікові години')} Value={(wndData['rightsShef']||{}).urPeakHours} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsShef','urPeakHours',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('популярні страви')} Value={(wndData['rightsShef']||{}).urPopularMenu} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsShef','urPopularMenu',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('стоп-лист')} Value={(wndData['rightsShef']||{}).urStopList} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsShef','urStopList',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('продажі в збиток')} Value={(wndData['rightsShef']||{}).urLossSoldGoods} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsShef','urLossSoldGoods',d)}} width1='180' width2='0'/><br />
    </fieldset>
    <fieldset style={{minWidth:'200px',maxWidth:'360px',padding:'2px',flexBasis:'200px',flexGrow:'1',display:fastVisibility?'block':'none'}}><legend>FastFood</legend>
        <EditCtrl Capt={localestr('друкувати рахунки')} Value={(wndData['rightsFast']||{}).urPrintPre} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFast','urPrintPre',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('працювати з вагою')} Value={(wndData['rightsFast']||{}).urWeight} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFast','urWeight',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('видаляти рядки')} Value={(wndData['rightsFast']||{}).urDelete} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFast','urDelete',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('робити відмову')} Value={(wndData['rightsFast']||{}).urReject} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFast','urReject',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('давати знижки')} Value={(wndData['rightsFast']||{}).urDiscount} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFast','urDiscount',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('закривати чеки')} Value={(wndData['rightsFast']||{}).urClose} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFast','urClose',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('робити випуск')} Value={(wndData['rightsFast']||{}).urProduction} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFast','urProduction',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('формувати загальні звіти')} Value={(wndData['rightsFast']||{}).urReport} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFast','urReport',d)}} width1='180' width2='0'/><br />
        <EditCtrl Capt={localestr('керувати фіск. апаратом')} Value={(wndData['rightsFast']||{}).urFiscal} typeVal={'l_check'} setVal={(d)=>{setCheck('rightsFast','urFiscal',d)}} width1='180' width2='0'/><br />
    </fieldset>
    </div>
    </Panel>
    <div style={{width:'54px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveValue()}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
    </div>
    )
    
}

export default CatUsersEdit